import { isCustomerSafePaymentText } from '@supply-mover-2-0/shared';
import { PaymentGatewayError } from '../../types/payment.types';

/**
 * PD-16778 — which errors from the browser-side card and bank tokenizers a
 * CUSTOMER may read as they are.
 *
 * The tokenizers throw two kinds of error. Field validation ("Card Number is
 * missing or invalid. Please check and try again.") is written for the person
 * filling in the form and tells them what to fix. Everything else is plumbing
 * written for a developer: hosted fields that were never set up ("NMI service
 * not initialized"), a gateway script that failed to load, a missing
 * tokenization key. Those often name the tenant's payment processor and give
 * the customer nothing to act on, so the storefront shows its own instruction
 * instead and logs the original.
 *
 * Allowlisted by code rather than screened by wording: the plumbing messages
 * do not reliably name a processor ('Card service not initialized. Call
 * initialize("CARD") first.'), so a wording blocklist would let them through.
 */
const CUSTOMER_FACING_TOKENIZATION_CODES: ReadonlySet<string> = new Set([
	'VALIDATION_ERROR',
	// Accept.js field errors; PaymentMethodForm replaces each with its own wording.
	'E_WC_05',
	'E_WC_06',
	'E_WC_07',
	'E_WC_15',
]);

export const isCustomerFacingTokenizationError = (
	error: unknown,
): error is PaymentGatewayError =>
	error instanceof PaymentGatewayError &&
	error.code != null &&
	CUSTOMER_FACING_TOKENIZATION_CODES.has(error.code) &&
	isCustomerSafePaymentText(error.message);
